var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.50008C15.5304 7.50008 16.0391 7.71079 16.4142 8.08586C16.7893 8.46093 17 8.96964 17 9.50008M21 9.50008C21.0003 10.4372 20.781 11.3615 20.3598 12.1986C19.9386 13.0358 19.3271 13.7627 18.5744 14.321C17.8216 14.8792 16.9486 15.2535 16.0252 15.4136C15.1018 15.5737 14.1538 15.5153 13.257 15.2431L11 17.5001H9V19.5001H7V21.5001H4C3.73478 21.5001 3.48043 21.3947 3.29289 21.2072C3.10536 21.0196 3 20.7653 3 20.5001V17.9141C3.00006 17.6489 3.10545 17.3946 3.293 17.2071L9.257 11.2431C9.00745 10.4181 8.93857 9.54902 9.05504 8.69502C9.17152 7.84102 9.47062 7.02215 9.93199 6.29412C10.3934 5.5661 11.0062 4.94602 11.7287 4.47609C12.4512 4.00617 13.2665 3.69743 14.1191 3.57088C14.9716 3.44434 15.8415 3.50296 16.6693 3.74276C17.4972 3.98256 18.2637 4.39791 18.9166 4.96054C19.5696 5.52317 20.0936 6.21987 20.4531 7.00322C20.8127 7.78656 20.9992 8.63817 21 9.50008Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey2);
export default __webpack_public_path__ + "static/media/key-2.b4c8c7eedc1186f8251cba81c7cdc3d0.svg";
export { ForwardRef as ReactComponent };